<template>
    <div id="payment-status">
        <div class="plan">
            <div class="highlight">
                <div class="spike"></div>
                <h2 class="period_amount">
                    <template
                        v-if="payment.status === 'pending'"
                    >
                        🕑
                    </template>
                    <template
                        v-else-if="payment.status === 'approved'"
                    >
                        ✔
                        <template v-if="aclidUrl">
                            <img
                                id="1000178711_cpa_testing"
                                :src="aclidUrl"
                                width="1"
                                height="1"
                                border="0"
                            />
                        </template>
                    </template>
                    <template
                        v-else
                    >
                        ✘
                    </template>
                </h2>
            </div>
            <div class="details">
                <template v-if="payment.is_preapproval">
                    <div class="right">
                        <h5 class="duration_type">
                            {{$t(`subscription_result.${payment.status}.title`)}}
                        </h5>
                        <h5 class="access_type">
                            {{$t(`subscription_result.${payment.status}.subtitle`)}}
                        </h5>
                    </div>
                </template>
                <template v-else>
                    <div class="right" :class="payment.status">
                        <h5 class="duration_type">
                            {{$t(`payment_result.${payment.status}.title`)}}
                        </h5>
                        <div
                            v-if="(payment.status === 'canceled' || payment.status === 'failed') && payment.data"
                            class="access_type"
                        >
                            <div
                                style="display: flex;justify-content: space-between;margin: 10px auto"
                            >
                                <div>{{ $t(`payment_result.${payment.status}.status`, {"status": payment.data.TRANS_STATUS_NAME}) }}</div>
                                <div>{{ $t(`payment_result.${payment.status}.trans_id`, {"trans_id": payment.data.TRANS_ID}) }}</div>
                            </div>
                            <div
                                style="margin: 5px auto"
                            >{{ payment.data.SERVICE_ADVICE }}</div>
                            <div>{{ payment.data.INDUSTRY_ADVICE }}</div>
                        </div>
                        <h5
                            v-else
                            class="access_type"
                        >
                            {{$t(`payment_result.${payment.status}.subtitle`)}}
                        </h5>
                    </div>
                </template>
            </div>
        </div>
    
        <div
            v-if="claimsFailedCard"
            class="try-again"
        >
            <h2>{{$t('payment_result.retry_message.title')}}</h2>
            <p>{{$t('payment_result.retry_message.subtitle')}}</p>
            <p>{{$t('payment_result.retry_message.try_again')}}</p>
        </div>
        
        <div
            v-if="claimsFailedCard"
            class="buttons"
        >
            <router-link
                :to="{ name: 'subscribe', query: { plan: payment.subscription_plan.data.id } }"
                class="btn main-btn"
            >
                {{$t('retry')}}
            </router-link>
        </div>
    </div>
</template>

<script>
  export default {
      props: {
          payment: {
              required: true,
              type: Object,
          }
      },
      data(){
          return {
              advertising: {
                  lastAclid: null,
              },
          }
      },
      mounted(){
          /* Advertising */
          try{
              this.advertising.lastAclid = localStorage.getItem('advertising.lastAclid');

              localStorage.removeItem('advertising.lastAclid')
          }catch(e){/* Do nothing */}
          /* Advertising */
        
          (this.claimsFailedCard) ? this.setFailedCard() : this.clearFailedCards();
          (this.claimsFailedCard) ? this.setPaymentFailed() : this.clearPaymentFailed();
      },
      methods: {
          setPaymentFailed(){
              localStorage.setItem('paymentFailed', this.payment.payment_method.data.id);
          },
          clearPaymentFailed(){
              localStorage.removeItem('paymentFailed')
          },
          setFailedCard(){
              let failedCards =  JSON.parse(localStorage.getItem('failedCards')) || [];
              let newFailedCard = {
                  "id": this.payment.user_credit_card.data.id,
                  "details": this.payment.data
              }
              failedCards.push(newFailedCard);
              localStorage.setItem('failedCards', JSON.stringify(failedCards));
          },
          clearFailedCards(){
              localStorage.removeItem('failedCards')
          },
      },
      computed: {
          aclidUrl(){
              if(!this.payment || !this.advertising.lastAclid){
                  return null;
              }

              const cacheBuster = + new Date() + (Math.random() * 1000).toFixed(0);
              return `http://ads.trafficjunky.net/tj_ads_pt?a=1000178711&member_id=1001477991&cb=${cacheBuster}&cti=${this.payment.operation_number || 'ND'}&ctv=${this.payment.amount}&ctd=${this.payment.is_preapproval ? 'PRE_APROBACION' : 'PAGO'}&aclid=${this.advertising.lastAclid}`
          },
          claimsPaymentFailed(){
              return ( this.payment && (this.payment.status === 'canceled' || this.payment.status === 'failed') );
          },
          claimsFailedCard(){
              return (
                        this.payment &&
                        (this.payment.status === 'canceled' || this.payment.status === 'failed') &&
                        this.payment.data
              );
          },
      },
  }
</script>

<style scoped lang="scss">
@import '../styles/classes';
@import '../styles/variables';

#payment-status{
    display: flex;
    flex-direction: column;
    align-items: center;

    .plan{
        @extend %plan-block;
        .details{
            background-color: $pallete_clear_color;
            color: $pallete_dark_text_color;
            min-width: 300px;
        
            @media(max-width: 400px){
                min-width: auto;
            }
        
            .right{
                &.failed{
                    .duration_type{
                        font-size: .9em;
                    }
                    .access_type{
                        font-size: .75em;
                    }
                }
            }
        }
    }

    .try-again{
        margin: 40px 0;
        text-align: center;
        text-transform: uppercase;
        h2{
            font-family: arial, helvetica;
            margin: 0;
        }
        p{
            font-style: italic;
            margin: 0;
        }
    }

    .buttons{
        display: block;
        height: auto;
        margin-top: 3em;
        text-align: center;
    
        .btn.main-btn{
            @extend %fresh-btn;
            padding: .5em;
        }
    }
}
</style>